import { Component, OnInit } from '@angular/core';
import Swiper, { EffectCreative }from 'swiper';
import { SwiperComponent } from "swiper/angular";

import SwiperCore, { Navigation, Pagination, EffectFade, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller } from "swiper";
SwiperCore.use([Navigation, Pagination, EffectFade, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller, EffectCreative]);
declare let $:any
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
showContent = true;
  constructor() { }

  ngOnInit(): void {
    const now = new Date();
    const hour = now.getHours(); // 24hr format

    // Hide after 5 PM
    if (hour >= 17) {
      this.showContent = false;
    }
  }
  ngAfterViewInit(){

    /*---------------------------
    :: Home slider
    -----------------------------*/
// new Swiper('.swiper-home-slide', {
//   slidesPerView: 1,
//   grabCursor: true,
//   loop:true,
//    // autoplay:
//    //  {
//    //    delay: 3000,
//    //  },
//    //  effect: 'fade',

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     type: 'bullets',
//     clickable: true,
//   },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },
// });

var swiper = new Swiper(".swiper-home-slide", {
  slidesPerView: 1,
  grabCursor: true,
  loop:true,
  autoplay:true,
  effect: "fade",
  speed: 2000,

  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
})



 }

}
